import * as React from "react";

function CommentQuestionIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M256 31.1C114.6 31.1.9 124.23.9 239.1c0 49.63 21.35 94.98 56.97 130.7-12.5 50.38-54.27 95.27-54.77 95.77-2.25 2.25-2.875 5.734-1.5 8.734 1.249 3 4.021 4.766 7.271 4.766 66.25 0 115.1-31.76 140.6-51.39 32.63 12.25 69.02 19.39 107.4 19.39 141.4 0 255.1-93.13 255.1-208S397.4 31.1 256 31.1zM249.1 352c-13.7 0-25.1-11.4-25.1-26s11.4-26 25.1-26c14.63 0 26 11.38 26 26s-10.5 26-26 26zm58.6-116.6-38.33 23.13v1.652c0 10.74-9.168 19.83-20 19.83-10.83 0-20-9.088-20-19.83V246.1c0-6.609 3.332-13.22 10-17.35l47.5-28.09c5.83-2.46 9.13-8.26 9.13-14.86 0-9.914-8.334-18.17-18.33-18.17H234.3c-10 0-18.33 8.26-18.33 18.17 0 10.74-9.166 19.83-20 19.83S176 196.6 176 185.8c0-32.2 25.8-57.8 58.3-57.8h43.33c32.57 0 58.37 25.6 58.37 57.8 0 19.9-10.8 38.9-28.3 49.6z"
  }));
}

const ForwardRef = React.forwardRef(CommentQuestionIcon);
export default ForwardRef;